// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2hbLR","inputWrap":"styles_inputWrap__1ZyJQ","input":"styles_input__Te7Sg"};